export const BusinessCenterIcon = ({ color = "#8D8D8D", size = 20, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0.5 0.5 20 20"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_13135_10215)">
      <path
        d="M8.83341 13.8333V13H3.00841L3.00008 16.3333C3.00008 17.2583 3.74175 18 4.66675 18H16.3334C17.2584 18 18.0001 17.2583 18.0001 16.3333V13H12.1667V13.8333H8.83341ZM17.1667 6.33333H13.8251V4.66667L12.1584 3H8.82508L7.15841 4.66667V6.33333H3.83341C2.91675 6.33333 2.16675 7.08333 2.16675 8V10.5C2.16675 11.425 2.90841 12.1667 3.83341 12.1667H8.83341V10.5H12.1667V12.1667H17.1667C18.0834 12.1667 18.8334 11.4167 18.8334 10.5V8C18.8334 7.08333 18.0834 6.33333 17.1667 6.33333ZM12.1667 6.33333H8.83341V4.66667H12.1667V6.33333Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_13135_10215">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0.5 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
